import { permissionManager } from "../PermissionManager/PermissionManager";

export const CONVERT_FILES_TO_PDF ='convert-files-to-pdf';
export const CONVERT_MUL_FILES_TO_PDF ='convert-mul-files-to-pdf';
export const CREATE_BLANK_PDF = 'create-blank-pdf';
export const CONVERT_CLIPBOARD_TO_PDF = 'convert-clipboard-to-pdf';
export const CONVERT_HTML_TO_PDF ='convert-html-to-pdf';
export const CONVERT_EXPORT_IMAGES ='convert-export-images';
export const CONVERT_PDF_TO_WORD ='convert-pdf-to-word';
export const CONVERT_PDF_TO_XML_SPREADSHEET_2003 ='convert-pdf-to-xml-spreadsheet-2003';
export const CONVERT_PDF_TO_WORD_2003 ='convert-pdf-to-word-2003';
export const CONVERT_PDF_TO_EXCEL ='convert-pdf-to-excel';
export const CONVERT_PDF_TO_PPT ='convert-pdf-to-ppt';
export const CONVERT_PDF_TO_PNG ='convert-pdf-to-png';
export const CONVERT_PDF_TO_JPEG ='convert-pdf-to-jpeg';
export const CONVERT_PDF_TO_JPEG2000 ='convert-pdf-to-jpeg2000';
export const CONVERT_PDF_TO_TIFF ='convert-pdf-to-tiff';
export const CONVERT_PDF_TO_BMP ='convert-pdf-to-bmp';
export const CONVERT_PDF_TO_XML_STARDARD ='convert-pdf-to-xml-stardard';
export const CONVERT_PDF_TO_RTF ='convert-pdf-to-rtf';
export const CONVERT_PDF_TO_TXT ='convert-pdf-to-txt';
export const CONVERT_PDF_TO_ACCESSIBLE_TXT ='convert-pdf-to-accessible-txt';
export const CONVERT_PDF_TO_HTML ='convert-pdf-to-html';
export const CONVERT_NEW_PORTFOLIO = 'convert-new-portfolio';
export const CONVERT_BLANK_PORTFOLIO = 'convert-blank-portfolio';
export const CONVERT_COMBINE_FILES = 'convert-merge-pdf';
export const CONVERT_FROM_TEMPLATE = 'convert-from-template';
export const CONVERT_PDF_TO_OFFICE = 'convert-pdf-to-office';
export const CONVERT_PDF_TO_IMAGE ='convert-pdf-to-image';
export const CONVERT_PDF_TO_OTHER ='convert-pdf-to-other';
export const CONVERT_TO_PDF_SETTINGS = 'convert-to-pdf-settings';
export const CONVERT_PREFLIGHT = 'convert-preflight';

export const CONVERT_SELECTION_TO_OTHER = 'fv--contextmenu-item-exportSelectionAs';
export const CONVERT_SELECTIONIMAGE_TO_IMAGE = 'fv--contextmenu-item-saveImageAs';

export const OCR_QUICK_RECOGNITION = 'quick-recognition';
export const HOME_OCR_QUICK_RECOGNITION = 'home-quick-recognition';

export const CONVERT_PREMIUM_CN_JP_BTN =[
    CONVERT_MUL_FILES_TO_PDF,
    CONVERT_CLIPBOARD_TO_PDF,
    CONVERT_HTML_TO_PDF,
    CONVERT_EXPORT_IMAGES,
    CONVERT_PDF_TO_WORD,
    CONVERT_PDF_TO_XML_SPREADSHEET_2003,
    CONVERT_PDF_TO_WORD_2003,
    CONVERT_PDF_TO_EXCEL,
    CONVERT_PDF_TO_PPT,
    CONVERT_PDF_TO_PNG,
    CONVERT_PDF_TO_JPEG,
    CONVERT_PDF_TO_JPEG2000,
    CONVERT_PDF_TO_TIFF,
    CONVERT_PDF_TO_XML_STARDARD,
    CONVERT_PDF_TO_BMP,
    CONVERT_PDF_TO_RTF,
    CONVERT_PDF_TO_TXT,
    CONVERT_PDF_TO_ACCESSIBLE_TXT,
    CONVERT_PDF_TO_HTML,
    CONVERT_NEW_PORTFOLIO,
    CONVERT_BLANK_PORTFOLIO,
    CONVERT_COMBINE_FILES,
    CONVERT_FROM_TEMPLATE,
    CONVERT_SELECTION_TO_OTHER,
    CONVERT_SELECTIONIMAGE_TO_IMAGE,
    OCR_QUICK_RECOGNITION,
    HOME_OCR_QUICK_RECOGNITION,
    CONVERT_PREFLIGHT,
];

permissionManager.registerCNJPPremiumFeatures(CONVERT_PREMIUM_CN_JP_BTN);

// premium features
const CONVERT_PREMIUM_BTNS = [
    // CONVERT_MUL_FILES_TO_PDF,
    CONVERT_CLIPBOARD_TO_PDF,
    CONVERT_HTML_TO_PDF,
    CONVERT_EXPORT_IMAGES,
    // CONVERT_PDF_TO_WORD,
    // CONVERT_PDF_TO_XML_SPREADSHEET_2003,
    // CONVERT_PDF_TO_WORD_2003,
    // CONVERT_PDF_TO_EXCEL,
    // CONVERT_PDF_TO_PPT,
    // CONVERT_PDF_TO_PNG,
    // CONVERT_PDF_TO_JPEG,
    // CONVERT_PDF_TO_JPEG2000,
    // CONVERT_PDF_TO_TIFF,
    // CONVERT_PDF_TO_XML_STARDARD,
    // CONVERT_PDF_TO_BMP,
    // CONVERT_PDF_TO_RTF,
    // CONVERT_PDF_TO_TXT,
    // CONVERT_PDF_TO_ACCESSIBLE_TXT,
    // CONVERT_PDF_TO_HTML,
    CONVERT_NEW_PORTFOLIO,
    CONVERT_BLANK_PORTFOLIO,
    CONVERT_COMBINE_FILES,
    // CONVERT_FROM_TEMPLATE,
    CONVERT_SELECTION_TO_OTHER,
    CONVERT_SELECTIONIMAGE_TO_IMAGE,
    OCR_QUICK_RECOGNITION,
    HOME_OCR_QUICK_RECOGNITION,
    CONVERT_PREFLIGHT,
];
/*
const CONVERT_AUTO_SIGN_IN = [
    CONVERT_FILES_TO_PDF
];
permissionManager.registerForceLoginFeatures(CONVERT_AUTO_SIGN_IN);
*/
permissionManager.registerPremiumFeatures(CONVERT_PREMIUM_BTNS);
const CONVERT_GROUP_PDF_TO_OFFICE = [
    CONVERT_PDF_TO_WORD,
    CONVERT_PDF_TO_WORD_2003,
    CONVERT_PDF_TO_EXCEL,
    CONVERT_PDF_TO_PPT,
];
export const GROUP_PDF_TO_OFFICE = 'PDF2Office';
permissionManager.resigterFeaturesGroup(GROUP_PDF_TO_OFFICE, CONVERT_GROUP_PDF_TO_OFFICE);
export const CONVERT_LIST = [
    CONVERT_FILES_TO_PDF,
    CONVERT_MUL_FILES_TO_PDF,
    CONVERT_TO_PDF_SETTINGS,
    //CONVERT_HTML_TO_PDF, // 
    CONVERT_EXPORT_IMAGES,
    CONVERT_PDF_TO_WORD,
    CONVERT_PDF_TO_XML_SPREADSHEET_2003,
    CONVERT_PDF_TO_WORD_2003,
    CONVERT_PDF_TO_EXCEL,
    CONVERT_PDF_TO_PPT,
    CONVERT_PDF_TO_PNG,
    CONVERT_PDF_TO_JPEG,
    CONVERT_PDF_TO_JPEG2000,
    CONVERT_PDF_TO_XML_STARDARD,
    CONVERT_PDF_TO_TIFF,
    CONVERT_PDF_TO_BMP,
    CONVERT_PDF_TO_RTF,
    CONVERT_PDF_TO_TXT,
    CONVERT_PDF_TO_ACCESSIBLE_TXT,
    CONVERT_PDF_TO_HTML,
    OCR_QUICK_RECOGNITION,
    CONVERT_PREFLIGHT,
];

export const CONVERT_ALL_LIST = [
    CONVERT_FILES_TO_PDF,
    CONVERT_MUL_FILES_TO_PDF,
    CONVERT_TO_PDF_SETTINGS,
    CREATE_BLANK_PDF,
    CONVERT_CLIPBOARD_TO_PDF,
    CONVERT_HTML_TO_PDF,
    CONVERT_EXPORT_IMAGES,
    CONVERT_PDF_TO_WORD,
    CONVERT_PDF_TO_XML_SPREADSHEET_2003,
    CONVERT_PDF_TO_WORD_2003,
    CONVERT_PDF_TO_EXCEL,
    CONVERT_PDF_TO_PPT,
    CONVERT_PDF_TO_PNG,
    CONVERT_PDF_TO_JPEG,
    CONVERT_PDF_TO_JPEG2000,
    CONVERT_PDF_TO_XML_STARDARD,
    CONVERT_PDF_TO_TIFF,
    CONVERT_PDF_TO_BMP,
    CONVERT_PDF_TO_RTF,
    CONVERT_PDF_TO_TXT,
    CONVERT_PDF_TO_ACCESSIBLE_TXT,
    CONVERT_PDF_TO_HTML,
    CONVERT_NEW_PORTFOLIO,
    CONVERT_BLANK_PORTFOLIO,
    CONVERT_COMBINE_FILES,
    CONVERT_FROM_TEMPLATE,
    OCR_QUICK_RECOGNITION,
    CONVERT_PREFLIGHT,
];



// PDF to  files: need 'extract' permission
export const CONVERT_PDF_TO_FILE_LIST = [
    CONVERT_EXPORT_IMAGES,
    CONVERT_PDF_TO_WORD,
    CONVERT_PDF_TO_XML_SPREADSHEET_2003,
    CONVERT_PDF_TO_WORD_2003,
    CONVERT_PDF_TO_EXCEL,
    CONVERT_PDF_TO_PPT,
    CONVERT_PDF_TO_PNG,
    CONVERT_PDF_TO_JPEG,
    CONVERT_PDF_TO_JPEG2000,
    CONVERT_PDF_TO_XML_STARDARD,
    CONVERT_PDF_TO_TIFF,
    CONVERT_PDF_TO_BMP,
    CONVERT_PDF_TO_RTF,
    CONVERT_PDF_TO_TXT,
    CONVERT_PDF_TO_ACCESSIBLE_TXT,
    CONVERT_PDF_TO_HTML,
    OCR_QUICK_RECOGNITION,
    CONVERT_PREFLIGHT,
];

export const CONVERT_MAP = {
    // TODO FOXIT 修改云编辑可拖入文件格式，pdf已默认写死，此处只保留图片格式
    // supportDocumentSuffixs: '.jpg,.jpe,.jpeg,.bmp,.dib,.png,.gif,.tiff,.jpx,.tif,.ppt,.pptx,.pot,.potx,.pptm,.ppsx,.ppsm,.potm,.doc,.docx,.rtf,.dot,.dotx,.docm,.dotm,.wpd,.vsd,.vsdx,.wps,.hwp,.xls,.xlsx,.xlt,.xltx,.xlsm,.xlsb,.xltm,.csv,.txt,.text,.html,.htm,.shtml',
    supportDocumentSuffixs: '.jpg,.jpe,.jpeg,.bmp,.dib,.png,.gif,.tiff,.jpx,.tif',
    toPdfSettings: {
        name: CONVERT_TO_PDF_SETTINGS,
        title: 'phantom_online:toolbar.convert.toPdfSettings.title',
        icon:'fv__icon-toolbar-to-pdf-settings'
    },
    files2pdf:{
        name: CONVERT_FILES_TO_PDF,
        title: 'phantom_online:toolbar.convert.files2pdf.title',
        icon:'fx-icon-sm fv__icon-toolbar-files-to-pdf'
    },
    filemultiple2pdf:{
        name: CONVERT_MUL_FILES_TO_PDF,
        title: 'phantom_online:toolbar.convert.filemultiple2pdf.title',
        icon:'fv__icon-toolbar-from-multiple-files'
    },
    createBlankPdf: {
        name: CREATE_BLANK_PDF,
        title: 'phantom_online:toolbar.convert.createBlankPdf.title',
        icon: 'fv__icon-toolbar-create-blank-pdf'
    },
    clipboard2pdf: {
        name: CONVERT_CLIPBOARD_TO_PDF,
        title: 'phantom_online:toolbar.convert.clipboard2Pdf.title',
        icon: 'fv__icon-toolbar-clipboard-to-pdf'
    },
    html2pdf:{
        name:CONVERT_HTML_TO_PDF,
        title:'phantom_online:toolbar.convert.html2pdf.title',
        icon:'fv__icon-toolbar-html-to-pdf'
    },
    fromtemplate:{
        name:CONVERT_FROM_TEMPLATE,
        title:'phantom_online:toolbar.convert.fromtemplate.title',
        icon:'fv__icon-toolbar-from-template'
    },
    newPortfolio:{
        name: CONVERT_NEW_PORTFOLIO,
        title: 'phantom_online:toolbar.convert.newPortfolio.title',
        icon:'fv__icon-toolbar-new-portfolio'
    },
    blankPortfolio:{
        name: CONVERT_BLANK_PORTFOLIO,
        title: 'phantom_online:toolbar.convert.blankPortfolio.title',
        icon:'fv__icon-toolbar-blank-portfolio'
    },
    combinefiles:{
        name:CONVERT_COMBINE_FILES,
        title:'phantom_online:toolbar.convert.combinefiles.title',
        icon:'fv__icon-toolbar-combine-files'
    },
    exportimages:{
        name:CONVERT_EXPORT_IMAGES,
        title:'phantom_online:toolbar.convert.exportimages.title',
        icon:'fv__icon-toolbar-export-images'
    },
    pdf2word:{
        name:CONVERT_PDF_TO_WORD,
        title:'phantom_online:toolbar.convert.pdf2word.title',
        icon:'fv__icon-toolbar-pdf-to-word'
    },
    pdf2xmlspreadsheet2003:{
        name:CONVERT_PDF_TO_XML_SPREADSHEET_2003,
        title:'phantom_online:toolbar.convert.pdf2xmlspreadsheet2003.title',
        icon:'fv__icon-toolbar-pdf-to-excel'
    },
    pdf2word2003:{
        name:CONVERT_PDF_TO_WORD_2003,
        title:'phantom_online:toolbar.convert.pdf2word2003.title',
        icon:'fv__icon-toolbar-pdf-to-word'
    },
    pdf2excel:{
        name:CONVERT_PDF_TO_EXCEL,
        title:'phantom_online:toolbar.convert.pdf2excel.title',
        icon:'fv__icon-toolbar-pdf-to-excel'
    },
    pdf2ppt:{
        name:CONVERT_PDF_TO_PPT,
        title:'phantom_online:toolbar.convert.pdf2ppt.title',
        icon:'fv__icon-toolbar-pdf-to-ppt'
    },
    pdf2png:{
        name:CONVERT_PDF_TO_PNG,
        title:'phantom_online:toolbar.convert.pdf2png.title',
        icon:'fv__icon-toolbar-pdf-to-png'
    },
    pdf2jpeg:{
        name:CONVERT_PDF_TO_JPEG,
        title:'phantom_online:toolbar.convert.pdf2jpeg.title',
        icon:'fv__icon-toolbar-pdf-to-jpeg'
    },
    pdf2jpeg2000:{
        name:CONVERT_PDF_TO_JPEG2000,
        title:'phantom_online:toolbar.convert.pdf2jpeg2000.title',
        icon:'fv__icon-toolbar-pdf-to-jpeg'
    },
    pdf2tiff:{
        name:CONVERT_PDF_TO_TIFF,
        title:'phantom_online:toolbar.convert.pdf2tiff.title',
        icon:'fv__icon-toolbar-pdf-to-tiff'
    },
    pdf2bmp:{
        name:CONVERT_PDF_TO_BMP,
        title:'phantom_online:toolbar.convert.pdf2bmp.title',
        icon:'fv__icon-toolbar-pdf-to-bmp'
    },
    pdf2stardardxml:{
        name:CONVERT_PDF_TO_XML_STARDARD,
        title:'phantom_online:toolbar.convert.pdf2stardardxml.title',
        icon:'fv__icon-toolbar-pdf-to-txt'
    },
    pdf2rtf:{
        name:CONVERT_PDF_TO_RTF,
        title:'phantom_online:toolbar.convert.pdf2rtf.title',
        icon:'fv__icon-toolbar-pdf-to-txt'
    },
    pdf2txt:{
        name:CONVERT_PDF_TO_TXT,
        title:'phantom_online:toolbar.convert.pdf2txt.title',
        icon:'fv__icon-toolbar-pdf-to-txt'
    },
    pdf2accessibletxt:{
        name:CONVERT_PDF_TO_ACCESSIBLE_TXT,
        title:'phantom_online:toolbar.convert.pdf2accessibletxt.title',
        icon:'fv__icon-toolbar-pdf-to-txt'
    },
    pdf2html:{
        name:CONVERT_PDF_TO_HTML,
        title:'phantom_online:toolbar.convert.pdf2html.title',
        icon:'fv__icon-toolbar-pdf-to-html'
    },
    ocrquickrecognition:{
        name: OCR_QUICK_RECOGNITION,
        title: 'phantom_online:toolbar.convert.ocrquickrecognition.title',
        icon: 'fv__icon-toolbar-ocr-quick-recognition',
    },
    preflight: {
        name: CONVERT_PREFLIGHT,
        title: 'phantom_online:toolbar.convert.preflight.title',
        icon: 'fx-icon-ribbon_convert_preflight-32',
    }
}
